import moment from 'moment'

export function findByEntityTypeAndEntityIdAndLevelAndCreatedAtBetween(query) {
  if (query.entityType && query.entityId && query.level && query.createdAt && query.createdAt[0] && query.createdAt[1]) {
    _maybeInitCreatedAtDates(query)
    return 'findByEntityTypeAndEntityIdAndLevelAndCreatedAtBetweenOrderByCreatedAtDesc'
      + '?entityType=' + query.entityType
      + '&entityId=' + query.entityId
      + '&level=' + query.level
      + '&from=' + query.createdAt[0]
      + '&to=' + query.createdAt[1]
  }
  return null
}

export function findByEntityTypeAndEntityIdAndLevel(query) {
  if (query.entityType && query.entityId && query.level) {
    return 'findByEntityTypeAndEntityIdAndLevelOrderByCreatedAtDesc'
      + '?entityType=' + query.entityType
      + '&entityId=' + query.entityId
      + '&level=' + query.level
  }

  return null
}

export function findByEntityTypeAndEntityIdAndCreatedAtBetween(query) {
  if (query.entityType && query.entityId && query.createdAt && query.createdAt[0] && query.createdAt[1]) {
    _maybeInitCreatedAtDates(query)
    return 'findByEntityTypeAndEntityIdAndCreatedAtBetweenOrderByCreatedAtDesc'
      + '?entityType=' + query.entityType
      + '&entityId=' + query.entityId
      + '&from=' + query.createdAt[0]
      + '&to=' + query.createdAt[1]
  }

  return null
}

export function findByEntityTypeAndLevelAndCreatedAtBetween(query) {
  if (query.entityType && query.level && query.createdAt && query.createdAt[0] && query.createdAt[1]) {
    _maybeInitCreatedAtDates(query)
    return 'findByEntityTypeAndLevelAndCreatedAtBetweenOrderByCreatedAtDesc'
      + '?entityType=' + query.entityType
      + '&level=' + query.level
      + '&from=' + query.createdAt[0]
      + '&to=' + query.createdAt[1]
  }

  return null
}

export function findByEntityIdAndLevelAndCreatedAtBetween(query) {
  if (query.entityId && query.level && query.createdAt && query.createdAt[0] && query.createdAt[1]) {
    _maybeInitCreatedAtDates(query)
    return 'findByEntityIdAndLevelAndCreatedAtBetweenOrderByCreatedAtDesc'
      + '?entityId=' + query.entityId
      + '&level=' + query.level
      + '&from=' + query.createdAt[0]
      + '&to=' + query.createdAt[1]
  }

  return null
}
export function findByEntityTypeAndEntityId(query) {
  if (query.entityType && query.entityId) {
    return 'findByEntityTypeAndEntityIdOrderByCreatedAtDesc'
      + '?entityType=' + query.entityType
      + '&entityId=' + query.entityId
  }

  return null
}

export function findByEntityTypeAndLevel(query) {
  if (query.entityType && query.level) {
    return 'findByEntityTypeAndLevelOrderByCreatedAtDesc'
      + '?entityType=' + query.entityType
      + '&level=' + query.level
  }

  return null
}

export function findByEntityTypeAndCreatedAtBetween(query) {
  if (query.entityType && query.createdAt && query.createdAt[0] && query.createdAt[1]) {
    _maybeInitCreatedAtDates(query)
    return 'findByEntityTypeAndCreatedAtBetweenOrderByCreatedAtDesc'
      + '?entityType=' + query.entityType
      + '&from=' + query.createdAt[0]
      + '&to=' + query.createdAt[1]
  }

  return null
}

export function findByEntityIdAndLevel(query) {
  if (query.entityId && query.level) {
    return 'findByEntityIdAndLevelOrderByCreatedAtDesc'
      + '?entityId=' + query.entityId
      + '&level=' + query.level
  }

  return null
}

export function findByEntityIdAndCreatedAtBetween(query) {
  if (query.entityId && query.createdAt && query.createdAt[0] && query.createdAt[1]) {
    _maybeInitCreatedAtDates(query)
    return 'findByEntityIdAndCreatedAtBetweenOrderByCreatedAtDesc'
      + '?entityId=' + query.entityId
      + '&from=' + query.createdAt[0]
      + '&to=' + query.createdAt[1]
  }

  return null
}
export function findByLevelAndCreatedAtBetween(query) {
  if (query.level && query.createdAt && query.createdAt[0] && query.createdAt[1]) {
    _maybeInitCreatedAtDates(query)
      return 'findByLevelAndCreatedAtBetweenOrderByCreatedAtDesc'
        + '?level=' + query.level
        + '&from=' + query.createdAt[0]
        + '&to=' + query.createdAt[1]
    }

  return null
}

export function findByLevel(query) {
  if (query.level) {
      return 'findByLevelOrderByCreatedAtDesc'
        + '?level=' + query.level
    }

  return null
}

export function findByCreatedAtBetween(query) {
  if (query.createdAt && query.createdAt[0] && query.createdAt[1]) {
    _maybeInitCreatedAtDates(query)
    return 'findByCreatedAtBetweenOrderByCreatedAtDesc'
        + '?from=' + query.createdAt[0]
        + '&to=' + query.createdAt[1]
  }

  return null
}
export function findByEntityId(query) {
  if (query.entityId) {
      return 'findByEntityIdOrderByCreatedAtDesc'
        + '?entityId=' + query.entityId
    }

  return null
}
export function findByEntityType(query) {
  if (query.entityType) {
    return 'findByEntityTypeOrderByCreatedAtDesc'
      + '?entityType=' + query.entityType
  }

  return null
}

function _maybeInitCreatedAtDates(query) {
  if (!moment.isDate(query.createdAt[0])) {
    query.createdAt[0] = moment(query.createdAt[0]).toDate()
  }

  if (!moment.isDate(query.createdAt[1])) {
    query.createdAt[1] = moment(query.createdAt[1]).toDate()
  }
}
